// @flow

export const moderate = "0 2px 4px 0 rgba(0, 0, 0, 0.5)";
export const light = "1px 1px 10px 0 rgba(21, 129, 186, 0.2)";
export const top = "0 0 4px 0 rgba(0, 0, 0, 0.1)";
export const defaultShadow = "0 1px 2px 0 rgba(0, 0, 0, 0.16)";
export const bottom = "0 2px 7px 0 rgba(0,0,0,0.1)";
